import { createSlice } from "@reduxjs/toolkit";
import { getSubscriptions } from "./actions";

const initialState = {
    subscriptions: [],
    choosedPlan: null,
    planModal: {
        show: false,
        type: "plan",
        step: "choose-plan",
        method: "credit-card",
        token: "",
    },
    tradingviewUsername: "",
    telegramModal: false,
};

export const planSlice = createSlice({
    name: "Plans",
    initialState,
    reducers: {
        showPlanModal: (state, action) => {
            state.planModal.show = action.payload.show;
            state.planModal.type = action.payload.type;
            state.planModal.step = action.payload.step;

            if (!action.payload.show) {
                state.choosedPlan = null;
            }
        },
        changePlanModalStep: (state, action) => {
            state.planModal.step = action.payload;
        },

        changePlanModalMethod: (state, action) => {
            state.planModal.method = action.payload;
        },

        choosePlan: (state, action) => {
            state.choosedPlan = action.payload;
        },

        setPlanDiscount: (state, action) => {
            let data = action.payload;

            state.choosedPlan.discountCode = data.discountCode;
            state.choosedPlan.discountPrice = data.prices;
        },

        setStripeToken: (state, action) => {
            state.planModal.token = action.payload;
        },

        setTelegramModal: (state, action) => {
            state.telegramModal = action.payload;
        },

        setTradingviewUsername: (state, action) => {
            state.tradingviewUsername = action.payload;
        },
    },
    extraReducers: {
        [getSubscriptions.fulfilled]: (state, action) => {
            let plans = action.payload;
            if (plans) {
                state.subscriptions = plans;
            }
        },
    },
});

// Action creators are generated for each case reducer function
export const {
    showPlanModal,
    changePlanModalStep,
    changePlanModalMethod,
    choosePlan,
    setPlanDiscount,
    setStripeToken,
    setTelegramModal,
    setTradingviewUsername,
} = planSlice.actions;

export default planSlice.reducer;